import { render, staticRenderFns } from "./EditorBlockImage.vue?vue&type=template&id=72db6ff1&scoped=true"
import script from "./EditorBlockImage.vue?vue&type=script&lang=js"
export * from "./EditorBlockImage.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockImage.vue?vue&type=style&index=0&id=72db6ff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72db6ff1",
  null
  
)

export default component.exports